import { ComponentProps } from 'react'
import { styled } from 'stitches.config'

export const Box = styled('div', {})

Box.displayName = 'Box'

export type BoxProps = ComponentProps<typeof Box>
